<template>
  <div class="edit-org">
    <ep-title title="修改资料"></ep-title>
    <div class="org-form">
      <Entform v-if="orgState==0" ref="modifyenff" @change="onSubmitenf"  :isUpdata='isUpdata'></Entform>
      <Govform v-if="orgState==1" ref="modifygov" @change="onSubmitgov"  :isUpdata='isUpdata'></Govform>
      <Parkform v-if="orgState==2" ref="modifypark" @change="onSubmitpark"  :isUpdata='isUpdata'></Parkform>
      <Wtfrom v-if="orgState==3" ref="modifywtf" @change="onSubmitwtf"  :isUpdata='isUpdata'></Wtfrom>
      <Otherform v-if="orgState==4" ref="modifyother" @change="onSubmitother"  :isUpdata='isUpdata'></Otherform>
    </div>
    <div class="org-control">
      <el-button type="primary" @click="confirm">提交</el-button>
      <el-button @click="closeconfirm">取消</el-button>
    </div>
  </div>
</template>
<script>
import Entform from '@/components/plan/Entform'
import Parkform from '@/components/plan/Parkform'
import Wtfrom from '@/components/plan/Wtform'
import Govform from '@/components/plan/Govform'
import Otherform from '@/components/plan/Otherform'
import company from '@/data/basic/plan/company.js'
import moment from 'moment'
export default {
  data() {
    return {
      orgState: 0,
      form: [],
      registryState: {},
      other_list: {},
      datalist: null,
      isUpdata: true
    }
  },
  computed: {
  },
  created() {
    this.orgState = JSON.parse(sessionStorage.orgStatus)
  },
  methods: {
    closeconfirm() {
      // this.$router.push('/myunit')
      this.$router.go(-1)
    },
    // 提交表单
    // 判断数据根据类型
    confirm() {
      if (this.orgState == 0) {
        this.$refs['modifyenff'].onSubmitenf()
      } else if (this.orgState == 1) {
        this.$refs['modifygov'].onSubmitgov()
      } else if (this.orgState == 2) {
        this.$refs['modifypark'].onSubmitpark()
      } else if (this.orgState == 3) {
        this.$refs['modifywtf'].onSubmitwtf()
      } else if (this.orgState == 4) {
        this.$refs['modifyother'].onSubmitother()
      }
    },
    // 提交企业表单
    onSubmitenf(form) {
      (async() => {
        let result = await company.modify_entp(form)
        if (result.status) {
          this.$message.success('修改申报单位信息成功');
          // this.$router.push('/myunit')
          this.$router.go(-1)
        } else {
          this.$message.error(result.msg);
        }
      })()
    },
    // 提交政府
    onSubmitgov(form) {
      (async() => {
        let result = await company.modify_gov(form)
        if (result.status) {
          this.$message.success('修改申报单位信息成功');
          // this.$router.push('/myunit')
          this.$router.go(-1)
        } else {
          this.$message.error(result.msg);
        }
      })()
    },
    // 工业园区
    onSubmitpark(form) {
      (async() => {
        let result = await company.modify_zone(form)
        if (result.status) {
          this.$message.success('修改申报单位信息成功');
          // this.$router.push('/myunit')
          this.$router.go(-1)
        } else {
          this.$message.error(result.msg);
        }
      })()
    },
    // 水源地
    onSubmitwtf(form) {
      (async() => {
        let result = await company.modify_water(form)
        if (result.status) {
          this.$message.success('修改申报单位信息成功');
          // this.$router.push('/myunit')
          this.$router.go(-1)
        } else {
          this.$message.error(result.msg);
        }
      })()
    },
    // 其他
    onSubmitother(form) {
      (async() => {
        let result = await company.modify_other(form)
        if (result.status) {
          this.$message.success('修改申报单位信息成功');
          // this.$router.push('/myunit')
          this.$router.go(-1)
        } else {
          this.$message.error(result.msg);
        }
      })()
    },
  },
  components: {
    Entform,
    Parkform,
    Wtfrom,
    Govform,
    Otherform
  }
}

</script>
<style lang="stylus" scoped>
.org-form {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-top: 20px;
}

.org-control {
  margin-left: 120px;
  margin-bottom: 22px;
}

</style>



// WEBPACK FOOTER //
// editunit.vue?68673104